import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function MatchValidator(controlName: string, matchingControlName: string): ValidatorFn {
  return (formGroup): ValidationErrors | null => {
    const formControl = formGroup.get(controlName) as AbstractControl;
    const matchingControl = formGroup.get(matchingControlName) as AbstractControl;

    if (matchingControl !== null && matchingControl.errors && !matchingControl.errors['matchValidator']) {
      return null;
    }

    const errors: ValidationErrors | null =
      formControl.value !== matchingControl.value ? { matchValidator: true } : null;
    matchingControl.setErrors(errors);

    return errors;
  };
}
